import { ptBR } from "date-fns/locale";
import { toast } from "react-toastify";
import { format, isValid } from "date-fns";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
//components
import Select from "../../../components/input/Select";
import Toggle from "../../../components/button/Toggle";
import NumberInput from "../../../components/input/NumberInput";
import CalendarInput from "../../../components/input/CalendarInput";
import MultipleSelect from "../../../components/input/MultipleSelect";
//services
import { getAccount } from "../../../services/GlobalRoles/getAccount";
import { postReportReceipts } from "../../../services/Report/postReportReceipts";
import { getParcelDescription } from "../../../services/GlobalRoles/getParcelDescription";
//hooks
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
//context
import { useAppContext } from "../../../context/AppContext";

const FiltersReceipts = ({
  setNow,
  setLogo,
  setUser,
  setTable,
  setVisible,
  setFilters,
  loading,
  setLoading,
  setMonth,
  setOwner,
}) => {
  const defaultValues = {
    orderBy: "block_land",
    type_period: 2,
    month: false,
    owner: false,
  };
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const form = useForm({ defaultValues });
  const errors = form.formState.errors;

  const optionsOrderBy = [
    {
      label: `${nomenclature[0].value}/${nomenclature[1].value}`,
      value: "block_land",
    },
    { label: "Parcela", value: "installment" },
    { label: "Cliente", value: "client" },
    { label: "Data vencimento", value: "due_date" },
    { label: "Data Recebimento", value: "payment_date" },
  ];

  const optionsStatus = [
    { label: "Em Aberto", value: 0 },
    { label: "Pago", value: 1 },
  ];

  const optionsTypes = [
    { label: "Por Lançamento", value: 1 },
    { label: "Vencimento", value: 2 },
    { label: "Recebimento", value: 3 },
    { label: "Por Baixa", value: 4 },
  ];

  const {
    client,
    enterprise,
    isLoadingClients,
    isLoadingEnterprises,
    blocks,
    isLoadingBlocks,
    selectEnterprise,
    selectBlock,
    lands,
    isLoadingLands,
  } = useOptionsSelect();

  const { data: accounts, isLoading: isLoadingAccounts } = useQuery({
    queryKey: ["accounts"],
    queryFn: () => getAccount(),
    enabled: !!permissions?.includes("145")
  });

  const { data: installmentDescriptions, isLoading: isLoadingInstallments } =
    useQuery({
      queryKey: ["installmentsDesc"],
      queryFn: () => getParcelDescription(),
      enabled: !!permissions?.includes("140")
    });

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const onSubmit = async (data) => {

    // Verificar se temos filtros específicos que permitem período maior
    const hasSpecificFilters = data.block_id || data.land_id || data.client_id;
    
    // Obtenha as datas do form (validação só se as datas existirem)
    let startDateFilter, endDateFilter, diffInMonths = 0;
    
    if (data.period_start && data.period_end) {
      startDateFilter = new Date(data.period_start);
      endDateFilter = new Date(data.period_end);

      if (isNaN(startDateFilter) || isNaN(endDateFilter)) {
        toast.error("Datas inválidas.");
        return;
      }

      diffInMonths = (endDateFilter.getFullYear() - startDateFilter.getFullYear()) * 12 + (endDateFilter.getMonth() - startDateFilter.getMonth());
    }

    // Aplicar regras de validação de período baseadas nos filtros
    if (data.period_start && data.period_end) {
      if (!hasSpecificFilters) {
        // SEM filtros específicos: limitamos a 12 meses (ou 60 se formato mensal)
        if (diffInMonths > 12 && !form.getValues('month')) {
          toast.warning("Sem filtros específicos (Cliente, Quadra ou Lote), o intervalo entre as datas não pode ser maior que 12 meses.");
          return;
        } else if (diffInMonths > 60 && form.getValues('month')) {
          toast.warning("Sem filtros específicos (Cliente, Quadra ou Lote), o intervalo entre as datas não pode ser maior que 60 meses no formato mensal.");
          return;
        }
      }
      // COM filtros específicos: sem limitação de período, pode buscar qualquer intervalo
    }

    setLoading(true);
    let account = "";
    let endDate = "";
    let orderBy = "";
    let labelLand = "";
    let startDate = "";
    let labelBlock = "";
    let typeParcel = "";
    let typePeriod = "";
    let clientLabel = "";
    let labelStatus = "";
    // console.log(data);
    typeParcel =
      data.installment_description_id &&
      data.installment_description_id.map((item) => item.name);
    data.installment_description_id =
      data.installment_description_id &&
      data.installment_description_id.map((item) => item.code);
    if (data.installment_id === null) {
      data.installment_id = undefined;
    }
    if (data.client_id) {
      clientLabel = client.find((item) => item.value === data.client_id)?.label;
    }
    labelBlock =
      data.block_id &&
      blocks.find((item) => item.value === data.block_id)?.label;
    labelLand =
      data.land_id && lands.find((item) => item.value === data.land_id)?.label;
    labelStatus =
      data.status !== undefined &&
      optionsStatus.find((item) => item.value === data.status)?.label;
    if (data.current_account_id) {
      const accountComplete = accounts.find(
        (item) => item.id === data.current_account_id
      );
      account = `${accountComplete.nameCompany} | ${accountComplete.name_bank} | Conta: ${accountComplete.account_number}`;
    }
    orderBy =
      data.orderBy &&
      optionsOrderBy.find((item) => item.value === data.orderBy)?.label;
    typePeriod =
      data.type_period &&
      optionsTypes.find((item) => item.value === data.type_period)?.label;

    if (data.period_start && data.period_end) {
      if (data.type_period === undefined) {
        toast.warning("Tipo do período é obrigatório!");
        setLoading(false);
        return;
      }
    }

    // Validação de período obrigatório baseada nos filtros
    if (!hasSpecificFilters) {
      // SEM filtros específicos: período é obrigatório
      if (!data.period_start || !data.period_end) {
        toast.warning("Sem filtros específicos (Cliente, Quadra ou Lote), as datas inicial e final são obrigatórias!");
        setLoading(false);
        return;
      }
      if (data.type_period === undefined) {
        toast.warning("Sem filtros específicos, o tipo do período é obrigatório!");
        setLoading(false);
        return;
      }
    }

    if (data.month) {
      data.format = "month";
      if (!data.period_start || !data.period_end) {
        toast.warning("No formato mensal, a data inicial e final são sempre obrigatórias!");
        setLoading(false);
        return;
      }
      if (data.type_period === undefined) {
        toast.warning("No formato mensal, o tipo do período é obrigatório!");
        setLoading(false);
        return;
      }
    } else if (data.owner) {
      data.format = "owners";
    } else {
      data.format = "default";
    }

    if (data.period_start !== undefined && isValid(data.period_start)) {
      startDate = format(data.period_start, "dd/MM/yyyy");
    }

    if (data.period_end !== undefined && isValid(data.period_end)) {
      endDate = format(data.period_end, "dd/MM/yyyy");
    }

    setMonth(data.month);
    setOwner(data.owner);
    delete data.month;
    delete data.owner;

    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    const today = new Date();
    const formattedDate = format(today, "dd 'de' MMMM 'de' yyyy", {
      locale: ptBR,
    });
    try {
      const response = await postReportReceipts(data);
      setNow(formattedDate);
      setTable(response);
      // console.log(response);
      const newFilters = [
        { title: "Cliente", content: clientLabel },
        { title: "Empreendimento", content: response.enterprise.name },
        { title: nomenclature[0].value, content: labelBlock },
        { title: nomenclature[1].value, content: labelLand },
        { title: "Conta", content: account },
        { title: "N° Baixa", content: data.installment_id },
        {
          title: "Período",
          content:
            startDate && endDate !== "" ? `de ${startDate} até ${endDate}` : "",
        },
        { title: "Ordenar por", content: orderBy },
        { title: "Tipos Parcelas", content: typeParcel },
        { title: "Tipo Período", content: typePeriod },
        { title: "Status", content: labelStatus },
      ];
      // console.log(newFilters);
      setFilters(newFilters);
      setUser(response.user.name);
      setLogo(response.enterprise.img);
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
      setVisible(true);
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      setLoading(false);
    }
  };
  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="row d-flex mt-4">
        <div className="col-xl-3 col-md-4 mb-xl-0 mb-3 form-group">
          <Select
            name="client_id"
            label={isLoadingClients ? "Carregando..." : "Cliente"}
            control={form.control}
            disabled={isLoadingClients}
            options={client}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-xl-0 mb-3 form-group">
          <Select
            name="enterprise_id"
            label={isLoadingEnterprises ? "Carregando..." : "Empreendimento*"}
            control={form.control}
            isRequired={true}
            disabled={isLoadingEnterprises}
            onChange={(e) => selectEnterprise(e)}
            options={enterprise}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-4 form-group">
          <Select
            name="block_id"
            label={isLoadingBlocks ? "Carregando..." : nomenclature[0].value}
            control={form.control}
            disabled={isLoadingBlocks || !form.getValues("enterprise_id")}
            onChange={(e) => selectBlock(e)}
            options={blocks}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <Select
            name="land_id"
            label={isLoadingLands ? "Carregando..." : nomenclature[1].value}
            control={form.control}
            errors={errors}
            options={lands ? lands : ""}
            disabled={isLoadingLands ? true : false || !form.getValues("block_id")}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <Select
            name="current_account_id"
            label={isLoadingAccounts ? "Carregando..." : "Conta Corrente"}
            control={form.control}
            errors={errors}
            disabled={isLoadingAccounts}
            options={
              accounts &&
              accounts.map((item) => {
                return {
                  label: `${item.nameCompany} | ${item.name_bank} | Conta: ${item.account_number} | Agencia: ${item.agency}`,
                  value: item.id,
                };
              })
            }
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <NumberInput
            name="installment_id"
            label="Número Baixa"
            control={form.control}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <CalendarInput
            name="period_start"
            control={form.control}
            errors={errors}
            label="Data início *"
            isRequired={true}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <CalendarInput
            name="period_end"
            label="Data Fim *"
            control={form.control}
            errors={errors}
            isRequired={true}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <Select
            name="orderBy"
            label="Ordenar por"
            control={form.control}
            errors={errors}
            options={optionsOrderBy}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <MultipleSelect
            name="installment_description_id"
            label={
              isLoadingInstallments ? "Carregando..." : "Tipos de Parcelas"
            }
            control={form.control}
            disabled={isLoadingInstallments}
            options={
              installmentDescriptions &&
              installmentDescriptions.map((parcel) => ({
                name: parcel.description,
                code: parcel.id,
              }))
            }
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <Select
            name="type_period"
            label="Tipo Período"
            control={form.control}
            errors={errors}
            options={optionsTypes}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3 form-group">
          <Select
            name="status"
            label="Situação"
            control={form.control}
            errors={errors}
            options={optionsStatus}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-2 form-group pt-3">
          <Toggle
            name="completed_automatic"
            onLabel="Baixa Automática"
            offLabel="Baixa Automática"
            control={form.control}
            preValue={false}
            getFormErrorMessage={getFormErrorMessage}
          />
        </div>
        <div className="col-xl-2 col-md-4 mb-2 form-group pt-3">
          <Toggle
            name="month"
            onLabel="Mês"
            offLabel="Mês"
            control={form.control}
            preValue={false}
            getFormErrorMessage={getFormErrorMessage}
          />
        </div>
        <div className="col-xl-2 col-md-4 mb-2 form-group pt-3">
          <Toggle
            name="owner"
            onLabel="Sócio"
            offLabel="Sócio"
            control={form.control}
            preValue={false}
            getFormErrorMessage={getFormErrorMessage}
          />
        </div>
        <div className="d-flex justify-content-end my-2">
          <div
            className={`${window.innerWidth <= 992 ? "w-25" : "col-md-1"
              } text-center`}
          >
            <Button
              type="submit"
              icon="fa fa-search"
              aria-label="Search"
              loading={loading}
              className={`rounded-3 py-2.5 w-100`}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default FiltersReceipts;
